import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-seting",
  "use": "icon-seting-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-seting\">\n<path d=\"M8.2,14.6l3.2,1.8H5.7c-0.6,0-0.9-0.4-0.9-0.9c0-0.6,0.4-0.9,0.9-0.9l0,0H8.2z M13,7.2l4,2.3v4.6l-4,2.3l-4-2.3V9.5L13,7.2z\n\t M14.9,3.5c0.6,0,0.9,0.4,0.9,0.9l0,0v3.4L13,6.3L8.2,9.1v4.6H3.8c-0.6,0-0.9-0.4-0.9-0.9l0,0V4.5c0-0.6,0.4-0.9,0.9-0.9H14.9z\n\t M13,10c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8l0,0c1,0,1.8-0.8,1.8-1.8S14.1,10,13,10z M13,10.9c0.6,0,0.9,0.4,0.9,0.9\n\ts-0.4,0.9-0.9,0.9c-0.6,0-0.9-0.4-0.9-0.9S12.6,10.9,13,10.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/seting.svg
// module id = MZ0a
// module chunks = 97